export default __webpack_public_path__ + "static/media/why-choose-us.6430ebf0.jpg";